
<div class="multipleRequirementsSelector">
  <v-sheet
      class="requirementSelection"
      elevation="5"
  >
    <v-slide-group
        v-model="requirementIndex"
        active-class="active"
        center-active
        show-arrows
        ref="requirements"
    >
      <v-slide-item
          v-for="{requirement, index} in visibleRequirements"
          :key="index"
          :value="index"
          v-slot="{ active, toggle }"
      >
        <v-sheet
            class="secondary requirement"
            :class="{active: active}"
            @click="selectRequirement(index)"
        >
          <span class="requirementLabel">{{ requirement.productName }}</span>
          <div class="selectedImageContainer">
            <div v-if="requirementNeedsAllImagesOfPerson(requirement.requirement)" class="allImagesIconContainer">
              <v-badge overlap bottom color="red" class="badge">
                <template v-slot:badge color="white">{{ getImages(requirement.requirement).length }}</template>
                <v-icon class="secondary--text" :size="$vuetify.breakpoint.xsOnly ? 40 : 70">photo_library</v-icon>
              </v-badge>
            </div>
            <ManuallyExpandableImagePreview v-else-if="value[index] && value[index][0]"
                                            class="selectedImage"
                                            :filter="requirements[index].productFilter"
                                            :small-height="getPreviewSize(index).height"
                                            :small-width="getPreviewSize(index).width"
                                            :image="getPreviewImage(index)"/>
            <img v-else-if="requirement.productImageUrl" :src="requirement.productImageUrl"
                 class="requirementProductImage">
            <v-icon v-else :size="$vuetify.breakpoint.xsOnly ? 40 : 70" class="addImageIcon">library_add</v-icon>
          </div>
        </v-sheet>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
  <div class="secondary imageSelectorContainer">
    <ImageSelector :value="value[requirementIndex][0]"
                   :key="person.code + ':' + requirementIndex"
                   :images="getImages(currentRequirement.requirement)"
                   :excluded-default-image-ids="excludedDefaultImageIds"
                   :productId="currentRequirement.productId"
                   :filter="currentRequirement.productFilter"
                   :select-all="currentRequirementNeedsAllImagesOfPerson"
                   :scrollable-container-parent-layers="2"
                   ref="imageSelector"
                   @input="onImageSelect(requirementIndex, ...arguments)"
    />
  </div>
</div>
